import memoize from 'lru-memoize';
import {createValidator, required, minLength} from 'utils/validation';

const passwordValidation = createValidator({
  password: [required, minLength(1)]
});
export default memoize(10)(passwordValidation);
